(function () {
  'use strict';

  if (!document.body.classList.contains('template-index')) return;

  var SCROLL_CONTAINER_SELECTORS = [
    '.section-rich-text .text-content',
    '.lp-home-product-card__content',
    '.lp-home-section-intro .text-content',
    '.lp-pro-voices__intro .text-content',
    '.image-banner .banner-box.text-content',
    '.section-newsletter .text-content',
    '.lp-assurance__intro',
    '.image-text-list .card-content',
    '.section-image-gallery .section-header',
    '.lp-ugc-compact__header',
  ];

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isVisibleElement(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.matches('[hidden], [aria-hidden="true"]')) return false;
    return el.offsetParent !== null || getComputedStyle(el).position === 'fixed';
  }

  function stripScrollTrigger(el) {
    el.classList.remove('scroll-trigger', 'animate--slide-in');
  }

  function prepareContainer(container) {
    if (!container || container.getAttribute('data-lp-home-reveal-ready') === 'true') return null;

    container.setAttribute('data-lp-home-reveal-ready', 'true');
    container.classList.add('lp-home-reveal');
    stripScrollTrigger(container);

    var children = Array.prototype.filter.call(container.children, isVisibleElement);

    children.forEach(function (child, index) {
      stripScrollTrigger(child);
      child.classList.add('lp-home-reveal__item');
      child.setAttribute('data-lp-home-reveal-line', String(index));

      if (
        child.classList.contains('text-content-buttons') ||
        child.classList.contains('card-buttons') ||
        child.classList.contains('lp-home-product-card__btn')
      ) {
        child.classList.add('lp-home-reveal__item--inline');
      }
    });

    if (children.length === 0) return null;

    if (reducedMotion) {
      container.classList.add('is-inview');
      return null;
    }

    return container;
  }

  function reveal(container) {
    if (!container) return;
    container.classList.add('is-inview');
  }

  function resetReveal(container) {
    if (!container) return;
    container.classList.remove('is-inview');
  }

  function replayReveal(container) {
    if (!container || reducedMotion) return;
    resetReveal(container);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        reveal(container);
      });
    });
  }

  function observeScrollContainers() {
    if (reducedMotion || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.lp-home-reveal').forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -2% 0px' }
    );

    document.querySelectorAll('.lp-home-reveal:not(.lp-home-reveal--carousel)').forEach(function (container) {
      observer.observe(container);
    });
  }

  function initCarouselHero() {
    var carousels = document.querySelectorAll('.template-index .carousal slider-component');

    carousels.forEach(function (carousel) {
      if (carousel.getAttribute('data-lp-home-reveal-carousel-ready') === 'true') return;
      carousel.setAttribute('data-lp-home-reveal-carousel-ready', 'true');

      var boxes = carousel.querySelectorAll('.banner-box.text-content');
      var prepared = [];

      boxes.forEach(function (box) {
        var container = prepareContainer(box);
        if (container) {
          container.classList.add('lp-home-reveal--carousel');
          prepared.push(container);
        }
      });

      if (prepared.length === 0) return;

      function revealActiveSlide(slide) {
        if (!slide) return;
        var box = slide.querySelector('.banner-box.text-content');
        if (!box || !box.classList.contains('lp-home-reveal')) return;

        prepared.forEach(resetReveal);
        replayReveal(box);
      }

      var activeSlide = carousel.querySelector('.slider-slide.active') || carousel.querySelector('.slider-slide');
      if (activeSlide) {
        window.requestAnimationFrame(function () {
          revealActiveSlide(activeSlide);
        });
      }

      window.setTimeout(function () {
        var slide = carousel.querySelector('.slider-slide.active') || carousel.querySelector('.slider-slide');
        revealActiveSlide(slide);
      }, 180);

      carousel.addEventListener('sliderChanged', function (event) {
        window.setTimeout(function () {
          revealActiveSlide(event.detail && event.detail.currentElement);
        }, 80);
      });
    });
  }

  function initAll() {
    SCROLL_CONTAINER_SELECTORS.forEach(function (selector) {
      document.querySelectorAll('.template-index ' + selector).forEach(function (container) {
        prepareContainer(container);
      });
    });

    initCarouselHero();
    observeScrollContainers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
